import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  useContext,
  useEffect,
  useState,
  useMemo,
} from 'react';
import {
  Box,
  Button,
  FormControlLabel,
  Checkbox,
  FormControl,
  TextField,
  useTheme,
} from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'dva';
import TitleML from '../TitleML/TitleML';
import StepsFourMLStyled from './StepsFourMLStyles';
import { Context } from '../../AddActivity';
import { RadioFieldCom, SelectFieldCom } from '../FormType';
import MessageML from '../MessageML';

const typeListRadios7 = [
  { value: '1', label: '开启中奖通知' },
  { value: '0', label: '关闭中奖通知' },
];
const typeListRadios8 = [
  { value: 'NOTICE_ONE', label: '仅通知一个渠道' },
  { value: 'NOTICE_ALL', label: '所有渠道同步通知' },
];

// 微信模板暂时写死
const noticePriority = [
  {
    sortNo: 1,
    noticeChannelType: 1,
    noticeChannelName: '微信模板消息',
  },
  {
    sortNo: 2,
    noticeChannelType: 2,
    noticeChannelName: '短信',
  },
];

export default forwardRef(
  ({ onSubmitSuccess, defaultValues, queryType = '' }, fRef) => {
    const theme = useTheme();
    const {
      handleSubmit,
      control,
      setValue,
      // errors,
      // getValues,
      // watch,
    } = useForm();
    const smsTemplateList = useSelector(
      (state) => state.sceneMarketing.smsTemplateList,
    );
    const wechatTemplateList = useSelector(
      (state) => state.sceneMarketing.wechatTemplateList,
    );
    const [mChecked, setMChecked] = useState();
    const [mContent, setMContent] = useState();
    const [wChecked, setWChecked] = useState();
    const [wContent, setWContent] = useState();
    const { ref } = useContext(Context);
    const submitRef = useRef(null);
    const clickInputRef = () => {
      submitRef.current.click();
    };
    useImperativeHandle(ref, () => ({
      // handleSubmit 就是暴露给父组件的方法
      clickInput: clickInputRef,
    }));

    useEffect(() => {
      for (let key in defaultValues) {
        setValue(key, defaultValues[key]);
      }
    }, [defaultValues, setValue]);

    useEffect(() => {
      setMChecked(defaultValues?.mChecked);
      setMContent(defaultValues?.mContent);
      setWChecked(defaultValues?.wChecked);
      setWContent(defaultValues?.wContent);
    }, [
      defaultValues?.mChecked,
      defaultValues?.mContent,
      defaultValues?.wChecked,
      defaultValues?.wContent,
    ]);
    const setMCheckedFun = (checked) => {
      setMChecked(checked);
      setValue('mChecked', checked);
    };
    const setWCheckedFun = (checked) => {
      setWChecked(checked);
      setValue('wChecked', checked);
    };
    const mTemplateList = useMemo(() => {
      if (Array.isArray(smsTemplateList) && smsTemplateList.length > 0) {
        return smsTemplateList.map((item) => ({
          name: item.title,
          value: item.id,
          content: item.content,
        }));
      }
      return [];
    }, [smsTemplateList]);

    const wTemplateList = useMemo(() => {
      if (Array.isArray(wechatTemplateList) && wechatTemplateList.length > 0) {
        return wechatTemplateList.map((item) => ({
          name: item.title,
          value: item.id,
          content: item.content,
        }));
      }
      return [];
    }, [wechatTemplateList]);

    const onSetMContent = (v) => {
      smsTemplateList.forEach((item) => {
        if (item.id === v) {
          setValue('mContent', item.content);
          setMContent(item.content);
          return;
        }
      });
    };
    const onSetWContent = (v) => {
      wechatTemplateList.forEach((item) => {
        if (item.id === v) {
          setValue('wContent', item.content);
          setWContent(item.content);
          return;
        }
      });
    };
    return (
      <StepsFourMLStyled theme={theme}>
        <Box className="step-one-wrap" ref={fRef} mr={22}>
          <form onSubmit={handleSubmit(onSubmitSuccess)}>
            <TitleML title="小程序通知" fontSize="19px" p="32px 0" />
            <Box>
              <Box sx={{ fontSize: 12, color: '#212100', marginBottom: '8px' }}>
                <span style={{ color: 'red' }}>*</span>小程序服务通知
              </Box>
              <Box className="display-row">
                <Controller
                  render={(pr) => (
                    <RadioFieldCom
                      pr={pr}
                      id="miniprogramNotice"
                      queryType={queryType}
                      typeList={typeListRadios7}
                      lWidth="auto"
                    />
                  )}
                  name="miniprogramNotice"
                  control={control}
                />
              </Box>
            </Box>
            <TitleML title="通知渠道" fontSize="19px" p="32px 0" />
            <Box className="message-wrap" display="flex" gap="0 32px">
              {/* 必须选中一项，两个可都选 */}
              <MessageML
                setChecked={setMCheckedFun}
                checked={mChecked}
                label="短信通知"
                content={mContent}
                queryType={queryType}
                control={control}
                name="mChecked"
              >
                <FormControl
                  variant="standard"
                  sx={{ width: '100%', marginTop: '16px' }}
                >
                  <Controller
                    render={(pr) => (
                      <SelectFieldCom
                        pr={pr}
                        typeList={mTemplateList}
                        queryType={queryType}
                        onSetContent={onSetMContent}
                      />
                    )}
                    label=""
                    name="mType"
                    variant="standard"
                    control={control}
                  />
                </FormControl>
              </MessageML>
              <MessageML
                setChecked={setWCheckedFun}
                checked={wChecked}
                label="公众号模板消息"
                content={wContent}
                queryType={queryType}
                control={control}
                name="wChecked"
              >
                <FormControl
                  variant="standard"
                  sx={{ width: '100%', marginTop: '16px' }}
                >
                  <Controller
                    render={(pr) => (
                      <SelectFieldCom
                        pr={pr}
                        typeList={wTemplateList}
                        queryType={queryType}
                        onSetContent={onSetWContent}
                      />
                    )}
                    label=""
                    name="wType"
                    variant="standard"
                    control={control}
                  />
                </FormControl>
              </MessageML>
            </Box>
            <TitleML title="通知规则" fontSize="19px" p="32px 0" />
            <Box className="display-row">
              <Controller
                render={(pr) => (
                  <RadioFieldCom
                    pr={pr}
                    id="noticeType"
                    queryType={queryType}
                    typeList={typeListRadios8}
                    lWidth="auto"
                    row={false}
                  >
                    <div className="notice-channel-box">
                      <div className="channel-box-title">
                        <span>通知优先级</span>
                        <span>通知渠道</span>
                      </div>
                      {noticePriority &&
                        noticePriority.map((item) => {
                          return (
                            <div
                              className="channel-box-content"
                              key={item?.sortNo}
                            >
                              <span>{item?.sortNo}</span>
                              <span>{item?.noticeChannelName}</span>
                            </div>
                          );
                        })}
                    </div>
                    <div className="member-rules">
                      同一个客户，多个渠道通知，有可能会骚扰客户，请谨慎使用
                    </div>
                  </RadioFieldCom>
                )}
                name="noticeType"
                control={control}
              />
            </Box>
            <Button type="submit" ref={submitRef} style={{ display: 'none' }} />
            <Box display="none">
              <Controller
                render={(pr) => (
                  <FormControlLabel
                    {...pr}
                    variant="standard"
                    checked={pr.value ?? false}
                    control={<Checkbox color="primary" />}
                    label=""
                    onChange={(e) => pr.onChange(e.target.checked)}
                  />
                )}
                control={control}
                name="mChecked"
              />
              <Controller
                render={(pr) => (
                  <TextField
                    variant="standard"
                    id="outlined-multiline-static"
                    autoComplete="off"
                    label=""
                    value={pr.value ?? ''}
                  />
                )}
                control={control}
                name="mContent"
              />
            </Box>
            <Box display="none">
              <Controller
                render={(pr) => (
                  <FormControlLabel
                    {...pr}
                    variant="standard"
                    checked={pr.value ?? false}
                    control={<Checkbox color="primary" />}
                    label=""
                    onChange={(e) => pr.onChange(e.target.checked)}
                  />
                )}
                control={control}
                name="wChecked"
              />
              <Controller
                render={(pr) => (
                  <TextField
                    variant="standard"
                    id="outlined-multiline-static"
                    autoComplete="off"
                    label=""
                    value={pr.value ?? ''}
                  />
                )}
                control={control}
                name="wContent"
              />
            </Box>
          </form>
        </Box>
      </StepsFourMLStyled>
    );
  },
);
